export const STATUS_RESPONSES = {
    USER_BLOCKED_BY_HOST: 1309,
    USER_BANNED_BY_ADMIN: 1120,
    USERNAME_HAS_BEEN_TAKEN: 759,
    USER_NOT_FOUND: 652,
    SUCCESS: 0,
    PRIVATE_ROOM: 798,
    USER_LOGGED_ANOTHER_DEVICE: 1008,
    INFO_INCORRECT: 966,
    INCORRECT_PASSWORD: 966,
    INVALID_MODEL: 750,
    DISPLAY_NAME_REQUIRED: 779,
    NOT_ENOUGH_MONEY: 1049,
    USER_NOT_VERIFY: 1426,
    EMAIL_EXISTED: 0,
    NOT_BUY_TICKET: 1994,
    ACCOUNT_DEACTIVE: 603,
    VERIFICATION_CODE_EXPIRED: 964,
    GIFT_NOT_AVAILABLE: 604,
    VOUCHER_INVALID: 1503,
    VOUCHER_USED: 1502,
    VOUCHER_NOT_EXIST: 1501,
    RESULT_FAIL: 7029,
    VIDEO_NOT_FOUND: 7002,
}

export const COOKIE_KEY = {
    USER_ID: "_lora_uid",
}

export const TIMEOUT_TRACKING = 3000 // call tracking after 3 seconds

export const MAX_RENDER_IN_VIEWPORT = 7 // max render in viewport

export const ECOMMERCE_SITE = {
    SHOPIFY: 1,
    OTHER: 2,
}

export const MANUAL_CART_EVENTS = {
    SYNC_PRODUCT: "SYNC_PRODUCT",
    SYNCED_PRODUCT: "SYNCED_PRODUCT",
    ADD_TO_CART: "ADD_TO_CART",
    UPDATE_ITEM_IN_CART: "UPDATE_ITEM_IN_CART",
    CHECKOUT: "CHECKOUT",
    SYNC_CART_STATE: "SYNC_CART_STATE",
}

export const CART_EVENTS = {
    OPEN_CART: "open_cart",
    CLOSE_CART: "hide_cart",
    ADD_TO_CART: "add_to_cart",
    REMOVE_FROM_CART: "remove_from_cart",
    DECREASE_FROM_CART: "decrease_from_cart",
}

export const DEFAULT_MIN_HEIGHT_TO_SHOW_BTN = 256
